import React from "react";
import { useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Breadcrumb } from "@gull";

import { Badge } from "react-bootstrap";

import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";

import CreateRoles from "./CreateRoles";
import { getRoles } from "app/services/permissionService";
import { FaTrash } from "react-icons/fa";
import EditRoles from "./EditRoles";
import Swal from "sweetalert2";
import { deleteRole } from "app/services/roleService";
import { useState } from "react";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";

const Roles = () => {
  const { canAdd, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canEdit, canDelete });
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);

  const userCountFormatter = (cell, row) => {
    return <p>{`${cell}  ${cell == 1 ? "user" : "users"} assigned`}</p>;
  };
  const lockFormatter = (cell, row) => {
    return cell == true ? (
      <Badge variant="danger">Locked</Badge>
    ) : (
      <Badge variant="success">Unlocked</Badge>
    );
  };

  const deleteRoleHandler = (row) => {
    Swal.fire({
      html: "Do you want to delete this role? ",
      showCancelButton: true,
      confirmButtonText: "Delete",

      cancelButtonText: "Back",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      icon: "warning",
      customClass: {
        popup: "swal-container",
        confirmButton: "btn btn-sm text-white",
        cancelButton: "btn btn-sm text-white",
      },

      preConfirm: async () => {
        const res = await deleteRole(row.roleId);
        return res;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value.status == "Success") {
          Swal.fire({
            icon: "success",
            text: result.value.message,
            customClass: {
              popup: "swal-container",
              confirmButton: "btn btn-sm text-white",
              cancelButton: "btn btn-sm text-white",
            },
          });
          await loadRoles();
        } else {
          Swal.fire({
            icon: "error",
            text: result.value.message,
            customClass: {
              popup: "swal-container",
              confirmButton: "btn btn-sm text-white",
              cancelButton: "btn btn-sm text-white",
            },
          });
        }
      }
    });
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        {canEdit && <EditRoles row={row} loadRoles={loadRoles} />}
        {canDelete && !row.userCount ? (
          <FaTrash
            className="text-danger ms-1 cursor-pointer"
            size={13}
            onClick={() => deleteRoleHandler(row)}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const columns = [
    {
      dataField: "roleName",
      text: "Role Name",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "description",
      text: "Description",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "400px" };
      },
    },
    {
      dataField: "userCount",
      text: "Assigned Users",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: userCountFormatter,
    },
    {
      dataField: "isLocked",
      text: "Lock / Unlock",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: lockFormatter,
    },
    {
      dataField: "roleId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const loadRoles = async () => {
    const response = await getRoles();

    const data = response.data;
    setData(data);
    setMainData(data);
  };
  useEffect(() => {
    loadRoles();
  }, []);

  const handleSearch = (value) => {
    const filterData = mainData.filter(
      (item) =>
        item.roleName?.toLowerCase().includes(value.toLowerCase()) ||
        item.description?.toLowerCase().includes(value.toLowerCase())
    );

    setData(filterData);
  };

  return (
    <>
      <Helmet>
        <title>Role Management</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Role Management" }]}></Breadcrumb>
      <div className="card card-body">
        <div className="row mb-2">
          <div className="col-12 col-md-9 mb-4">
            <div className="d-flex">
              <span className="mt-2 me-2">Search: </span>
              <input
                type="search"
                className="form-control searchBar"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          {canAdd && (
            <div className="col-12 col-md-3">
              <Button
                className="btn btn-primary btn-md float-end"
                variant="solid"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#createRoleModal"
              >
                Create Role
              </Button>
            </div>
          )}
        </div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              remote
              keyField="roleId"
              data={data}
              columns={
                canEdit ? columns : columns.filter((x) => x.text !== "Action")
              }
              pagination={paginationFactory()}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
        <CreateRoles loadRoles={loadRoles} />
      </div>
    </>
  );
};

export default Roles;
